import { TableCellEmpty } from '../../TableCellEmpty'
import { TableCellBase } from '../TableCellBase'

function TableEmptyCell({ ref, unread, value, ...cellProps }) {
  return (
    <TableCellBase {...cellProps} ref={ref}>
      <TableCellEmpty unread={unread} value={value} />
    </TableCellBase>
  )
}

export default TableEmptyCell
